export const muiCheckbox = {
    styleOverrides: {
        root: {
            padding: '5px'
        }
    }
}